import React from "react";
import { useNavigate } from "react-router-dom";
import { Check } from "lucide-react";
import { useLang } from "../../i18n";
import { Reveal } from "../motion";
import { HerbSprig, AvocadoDoodle } from "../Botanicals";
import { SUBSCRIPTIONS_COMING_SOON } from "../../lib/config";

const MembershipCTA = () => {
  const { t, lang } = useLang();
  const navigate = useNavigate();
  const perks = lang === "fr"
    ? ["Basic — 4,99 $/mois · Revue mensuelle PDF + infolettre",
       "Découverte — 9,99 $/mois · 30 recettes IA + articles exclusifs + revue mensuelle PDF incluse"]
    : ["Basic — $4.99/mo · Monthly PDF magazine + 10 AI mood-boosting recipes",
       "Découverte — $9.99/mo · 30 AI mood-boosting recipes + exclusive articles + monthly PDF magazine included"];

  return (
    <section data-testid="membership-cta" className="relative overflow-hidden bg-secondary/25 border-y border-border">
      <HerbSprig className="pointer-events-none absolute top-10 right-8 w-16 text-primary/25 animate-sway hidden lg:block" />
      <AvocadoDoodle className="pointer-events-none absolute bottom-8 left-6 w-14 text-primary/20 animate-sway hidden lg:block" />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-28 lg:py-36 grid lg:grid-cols-2 gap-16 items-center">
        <Reveal>
          <p className="text-primary/70 text-xs uppercase tracking-[0.25em] mb-6">{t("nav.members")}</p>
          <h2 className="font-serif text-4xl md:text-6xl leading-[1.02] tracking-tightest text-foreground mb-6">{t("members.title")}</h2>
          <p className="text-foreground/70 font-light text-lg mb-8 max-w-md">{t("members.sub")}</p>
          <ul className="space-y-3 mb-10">
            {perks.map((p, i) => (
              <li key={i} className="flex items-center gap-3 text-foreground/80">
                <span className="w-6 h-6 bg-primary text-primary-foreground flex items-center justify-center flex-shrink-0"><Check className="w-3.5 h-3.5" /></span>
                {p}
              </li>
            ))}
          </ul>
          <button
            data-testid="membership-join"
            onClick={() => navigate("/members")}
            disabled={SUBSCRIPTIONS_COMING_SOON}
            className={`px-8 py-4 text-sm font-medium transition-[transform,background-color] duration-200 ${
              SUBSCRIPTIONS_COMING_SOON
                ? "bg-muted text-foreground/60 border border-border cursor-not-allowed"
                : "bg-primary text-primary-foreground hover:bg-primary/90 active:scale-95"
            }`}
          >
            {SUBSCRIPTIONS_COMING_SOON
              ? (lang === "fr" ? "Bientôt disponible" : "Coming soon")
              : t("members.join")}
          </button>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="relative">
            <img src={`${process.env.REACT_APP_BACKEND_URL}/api/files/sereva/media/a13eb9e1-459d-49ec-97e4-d37119ab6dee.jpeg`} alt="" className="w-full h-[460px] object-cover rounded-[2rem]" />
            <div className="absolute bottom-6 right-6 bg-background px-8 py-6 border border-border">
              <p className="text-xs text-foreground/60 uppercase tracking-wider mb-1">{lang === "fr" ? "À partir de" : "From"}</p>
              <p className="font-serif text-5xl text-foreground leading-none">4,99 $<span className="text-lg text-foreground/50">{t("shop.perMonth")}</span></p>
              <p className="text-xs text-foreground/60 mt-2 uppercase tracking-wider">Abonnement Nordicvy · 2 {lang === "fr" ? "forfaits" : "tiers"}</p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default MembershipCTA;
